import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmationDialogData {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  /** When true, shows a reason/comment textarea before confirming. */
  showReasonInput?: boolean;
  /** Label shown above the textarea. Defaults to 'Reason'. */
  reasonLabel?: string;
  /** Whether the reason is required before confirming. */
  reasonRequired?: boolean;
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: false,
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  title: string;
  message: string;
  confirmButtonText: string;
  cancelButtonText: string;
  showReasonInput: boolean;
  reasonLabel: string;
  reasonRequired: boolean;
  reason = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    this.title = data.title || 'Confirm';
    this.message = data.message || 'Are you sure you want to proceed?';
    this.confirmButtonText = data.confirmButtonText || 'Confirm';
    this.cancelButtonText = data.cancelButtonText || 'Cancel';
    this.showReasonInput = !!data.showReasonInput;
    this.reasonLabel = data.reasonLabel || 'Reason';
    this.reasonRequired = !!data.reasonRequired;
  }

  get canConfirm(): boolean {
    if (this.showReasonInput && this.reasonRequired) {
      return this.reason.trim().length > 0;
    }
    return true;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    if (!this.canConfirm) return;
    if (this.showReasonInput) {
      this.dialogRef.close({ confirmed: true, reason: this.reason.trim() });
    } else {
      this.dialogRef.close(true);
    }
  }
}
